import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import HeaderLogo from '../assets/header/footer_mobile.svg';
import item1 from '../assets/image/Footer/twitter_normal.svg';
import item2 from '../assets/image/Footer/medium_normal.svg';
import item3 from '../assets/image/Footer/telegram_normal.svg';
import item4 from '../assets/image/Footer/Linkedin_normal.svg';
import item5 from '../assets/image/Footer/gitbook_normal.svg';
import item7 from '../assets/image/Footer/email_normal.svg';
import item1_hover from '../assets/image/Footer/twitter_hover.svg';
import item2_hover from '../assets/image/Footer/medium_hover.svg';
import item3_hover from '../assets/image/Footer/telegram_hover.svg';
import item4_hover from '../assets/image/Footer/Linkedin_hover.svg';
import item5_hover from '../assets/image/Footer/gitbook_hover.svg';
import item7_hover from '../assets/image/Footer/email_hover.svg';
import jump from '../assets/header/jump_grey.svg';
import jump_hover from '../assets/header/jump_hover.svg';
import { NavLink, useHistory } from 'react-router-dom';
const FooterDom = styled.div `
  width: 100%;
  height: fit-content;
  background: #000;

  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: 100%;
    height: fit-content;
  `}
  &.builder {
    position: fixed;
    bottom: 0;
    z-index: 666;
  }

  .container {
    padding: 0 73rem;
    height: 72rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${({ theme }) => theme.mediaWidth.upToSmall `
      padding: 0 16rem;
      height: 72rem;
      flex-wrap: wrap;
    `}
    .partner {
      ${({ theme }) => theme.mediaWidth.upToSmall `
        width: 100vw
      `}
      display: flex;
      justify-content: center;
      .item {
      }

      .item1 {
      }
    }
  }

  .bottom {
    height: 72rem;
    width: 100%;
    border-top: 1rem solid #2E2E2E;
    font-family: var(--netx-font);
    font-weight: 400;
    font-size: 16rem;
    color: #A2A2A2;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ theme }) => theme.mediaWidth.upToSmall `
        height: 44rem;
        font-size: 9rem;
    `}
  }
`;
// const Logo = styled.a`
//   width: 149rem;
//   height: 32rem;
//   background: url(${HeaderLogo}) no-repeat;
//   background-size: 100% 100%;
//   cursor: pointer;
//   ${({theme}) => theme.mediaWidth.upToSmall`
//       width: 90rem;
//       height: 24rem;
//       margin: 0 auto
//    `}
// `
const LinkDom = styled.a `
  display: block;
  width: 40rem;
  height: 40rem;
 

  background-image: ${({ bg }) => bg && `url(${bg})`};
  background-size: 100% 100%;
  cursor: pointer;

  &:hover {
    background-image: ${({ bghover }) => bghover && `url(${bghover})`};
    background-size: 100% 100%;
  }


`;
export default function MobileFooter({ className }) {
    const history = useHistory();
    const { t } = useTranslation('nav');
    const ImgDate = [item1, item2, item3, item4, item5, item7];
    const ImgDate_Hover = [item1_hover, item2_hover, item3_hover, item4_hover, item5_hover, item7_hover];
    const LinkJump = [
        'https://x.com/netx_world',
        'https://medium.com/@netxworld',
        'https://t.me/NetXPlatform',
        'https://www.linkedin.com/company/netx-foundation',
        'https://netx.gitbook.io/netx-docs',
        'mailto:contact@netx.world'
    ];
    const LinkDomContainer = ({ num }) => {
        const imageUrl = ImgDate[num];
        const imageHoverUrl = ImgDate_Hover[num];
        const href = LinkJump[num];
        const isMailLink = href.startsWith('mailto:');
        return (_jsx(LinkDom, { className: `item${num} item`, bg: imageUrl, bghover: imageHoverUrl, href: href, target: isMailLink ? undefined : '_blank', rel: isMailLink ? undefined : 'noopener noreferrer' }));
    };
    let menuItems = [
        {
            title: t('footer.ecosystem'),
            items: [
                { name: t('footer.nexus'), pathUrl: 'Nexus' },
                { name: t('footer.agentOS'), pathUrl: 'AgentOS' },
                { name: t('footer.payments'), pathUrl: 'payments' },
            ]
        },
        {
            title: t('footer.build'),
            items: [
                { name: t('footer.netxscan'), link: 'https://netxscan.io/', showRightPoint: true },
                { name: t('footer.faucet'), link: 'https://netx.world/faucet', target: '_self' },
                { name: t('footer.bridge'), pathUrl: 'bridge' },
            ]
        },
        {
            title: t('footer.participate'),
            items: [
                { name: t('footer.exchange'), pathUrl: 'exchange' },
                { name: t('footer.aiEngineer'), pathUrl: 'AI_engineer' },
                { name: t('footer.partnership'), pathUrl: 'partnership' },
                { name: t('footer.genesisBundle'), pathUrl: 'Genesis_Bundle' },
            ]
        },
        {
            title: t('footer.learn'),
            items: [
                { name: t('footer.technology'), pathUrl: 'technology' },
                { name: t('footer.economy'), pathUrl: 'economy' },
                { name: t('footer.tokenRelease'), pathUrl: 'token-release' },
                { name: t('footer.trustedComputing'), pathUrl: 'trusted_computing' },
                { name: t('footer.communityResearch'), pathUrl: 'research' },
                { name: t('footer.whitepaper'), link: 'https://netx.gitbook.io/netx-docs/whitepaper/netx-enterprise-framework-nef', showRightPoint: true },
                { name: t('footer.roadmap'), link: 'https://netx.gitbook.io/netx-docs/roadmap', showRightPoint: true },
                { name: t('footer.brandResources'), link: 'https://netx.gitbook.io/netx-docs/brand-resources', showRightPoint: true },
            ]
        }
    ];
    return (_jsxs(FooterWrapper, { children: [_jsxs(FooterContent, { children: [_jsxs(LogoSection, { children: [_jsx(Logo, { src: HeaderLogo, alt: "NetX Logo", onClick: () => {
                                    history.push('/');
                                } }), _jsx(IntroText, { children: t('tagline') }), _jsx(SocialIcons, { children: ImgDate.map((item, index) => (_jsx(LinkDomContainer, { num: index }, index))) })] }), _jsx(MenuSection, { children: menuItems.map((menu, index) => (_jsxs(MenuColumn, { children: [_jsx(MenuTitle, { children: menu.title }), _jsx(MenuItemsDom, { children: menu.items.map((item, itemIndex) => {
                                        return (_jsx(React.Fragment, { children: item.link ? _jsxs(MenuItem, { href: item.link, target: item.target ? item.target : '_blank', rel: "noopener noreferrer", children: [item.name, item.showRightPoint && _jsx(PointRight, { className: 'jump' })] }) : item.pathUrl ? _jsxs(NavLink, { to: `/${item.pathUrl}`, children: [item.name, item.showRightPoint && _jsx(PointRight, { className: 'jump' })] }) : _jsxs(MenuPlaceholder, { children: [item.name, item.showRightPoint && _jsx(PointRight, { className: 'jump' })] }) }, item.name));
                                    }) })] }, index))) })] }), _jsx(Divider, {}), _jsxs(LegalSection, { children: [_jsxs(ComplianceText, { children: [t('footer.compliance'), ' ', _jsx("a", { href: "https://netx.gitbook.io/netx-docs/netx-compliance-and-service-agreement", target: "_blank", rel: "noopener noreferrer", children: t('footer.learnMore') })] }), _jsx(Copyright, { children: t('footer.copyright') })] })] }));
}
const FooterWrapper = styled.footer `
  width: 100%;
  /* background: #101D42; */
  color: #FFFFFF;
  font-family: var(--netx-font);
`;
const FooterContent = styled.div `
  width: 100%;
  padding: 60rem 24rem 54rem;
`;
const LogoSection = styled.div `
  width: 100%;
  padding-bottom: 38rem;
`;
const Logo = styled.img `
  width: 100rem;
  height: 42rem;
  margin-bottom: 8rem;
  cursor: pointer;
`;
const IntroText = styled.div `
  font-family: var(--netx-font);
  font-size: 14rem;
  font-weight: 400;
  line-height: 18rem;
  color: #FFFFFF;
  margin-bottom: 24rem;
`;
const SocialIcons = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 24rem 20rem;
`;
const MenuSection = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32rem;
`;
const PointRight = styled.div `
  display: inline-block;
  width: 16rem;
  height: 16rem;
  margin-left: 8rem;
  background: url(${jump});
  background-size: 100% 100%;

`;
const MenuColumn = styled.div `

  >a{
    color: rgba(255, 255, 255, 0.62);
  font-size: 16rem;
  font-weight: 300;
  margin-bottom: 24rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: var(--netx-font);
  text-decoration: none;
  &:hover {
    color: #FFFFFF;
    .jump{
      background: url(${jump_hover});
      background-size: 100% 100%;
    }
  }
  }
`;
const MenuTitle = styled.h4 `
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 16rem;
  color: #FFFFFF;
  line-height: 20rem;
  margin-bottom: 16rem;
  padding-top: 0;
`;
const MenuItemsDom = styled.div `
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 28rem;
  row-gap: 16rem;

  >a {
    color: rgba(255, 255, 255, 0.62);
    font-size: 14rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    min-height: 18rem;
    cursor: pointer;
    font-family: var(--netx-font);
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      color: #FFFFFF;
      .jump{
        background: url(${jump_hover});
        background-size: 100% 100%;
      }
    }
  }
`;
const MenuItem = styled.a `
  color: rgba(255, 255, 255, 0.62);
  font-size: 14rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: var(--netx-font);
  text-decoration: none;
  white-space: nowrap;
  &:hover {
    color: #FFFFFF;
    .jump{
      background: url(${jump_hover});
      background-size: 100% 100%;
    }
  }
`;
const MenuPlaceholder = styled.span `
  color: rgba(255, 255, 255, 0.62);
  font-size: 14rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  min-height: 18rem;
  font-family: var(--netx-font);
  white-space: nowrap;
`;
const Divider = styled.hr `
  border: none;
  border-top: 1rem solid #2e2e2e;
  margin: 0;
`;
const LegalSection = styled.div `
  padding: 32rem 24rem 30rem;
`;
const ComplianceText = styled.p `
  max-width: 327rem;
  margin: 0 auto 20rem;
  text-align: center;
  font-size: 12rem;
  font-weight: 300;
  line-height: 14rem;
  color: rgba(159, 164, 179, 1);

  a {
    color: rgba(26, 105, 255, 1);
    text-decoration: underline;
    text-underline-offset: 2rem;
  }
`;
const Copyright = styled.p `
  margin: 0;
  text-align: center;
  font-size: 12rem;
  font-weight: 300;
  color: #9FA4B3;
`;
